/**
 * All WhatsApp API endpoints in one place.
 * Single source of truth — if a URL changes, fix it here only.
 */
export const WHATSAPP_ENDPOINTS = {
  // Contacts
  GET_CONTACTS: "/conversation/get-contacts",

  // Conversation / Messages
  GET_CONVERSATION_SENTIMENT: "/conversation/get-conversation-sentiment",
  GET_MEDIA_HISTORY: "/conversation/get-whatsapp-messages-media-history",

  // WhatsApp Status
  GET_WHATSAPP_STATUS: "/conversation/get-whatsapp-status",
  GET_CONNECTION_STATUS: "/conversation/status",

  // User Settings
  UPSERT_USER_SETTING: "/siteConfiguration/upsert-user-setting",
  GET_MODULE_SETTINGS: "/siteConfiguration/get-company-outlet-module-settings",
  UPSERT_MODULE_SETTING: "/siteConfiguration/upsert-company-outlet-module-setting",

  // User Data Scope (Assignees)
  GET_USER_DATA_SCOPE: "/user/get-user-data-scope",
} as const;
